import { OcadoEnvironment } from "../app/shared/shared.types";
import config from '../auth_config_tst.json';

const { domain, clientId, authorizationParams: { audience, scope }, apiUri, errorPath } = config as {
  domain: string;
  clientId: string;
  authorizationParams: {
    audience?: string;
    scope?: string;
  },
  apiUri: string;
  errorPath: string;
};

export const environment = {
  production: false,
  outage: Boolean((window as any).__env?.outage),
  outageMessage: (window as any).__env?.outageMessage || 'The application is currently down for maintenance. Please try again later.',
  gcpProjectId: 'orl-dev-coml-prj01',
  guid: {
    modellingToolModelMetaDataGuid: "887554b5-e31d-4acd-8412-c563e895451f",
    modellingToolParamsGuid: "d5ced979-1fe0-447f-9ad5-8fb45384a0b3",
    customModellingToolParamsGuid: "d5ced979-1fe0-447f-9ad5-8fb45384a0b3",
    modelling_tool_newGuid: "6136388d-fb07-47f7-b186-75decc66a77f",
    modelling_tool_historyGuid: "17d561f5-f75a-4301-bb5a-89a2f14fe49d",
  },
  baseApi: {
    document: 'https://tst-commercial.ocadohub.com',
    notification: 'https://tst-commercial.ocadohub.com',
    plan: 'https://tst-commercial.ocadohub.com',
    suphub: 'https://tst.ocadohub.com',
    promo: 'https://tst-promo.ocadohub.com',
    commercial: 'https://tst-commercial.ocadohub.com',
    media: 'https://ppd-ocado.zitcha.app',
    learn: 'https://ocadohub.learnstaging.link',
    walnut: 'https://orl.learnstaging.link',
    beet: 'https://www.beet-insight.com',
  },
  environment: OcadoEnvironment.TST,
  auth: {
    domain,
    clientId,
    authorizationParams: {
      ...(audience && audience !== 'YOUR_API_IDENTIFIER' ? { audience } : null),
      scope: scope,
      redirect_uri: window.location.origin,
    },
    errorPath,
  },
  httpInterceptor: {
    allowedList: [`${apiUri}/*`],
  },
  box: {
      folderId: 275025661777,
      folderName: "TST Ocado Retail"
  }
};
